export enum MailTemplate {
    // ========================= SIMPLE =========================
    SIMPLE_TEXT_V1,

    // ======================== FILLABLE ========================
    FILLABLE_FORM_FILLED_V1,
    FILLABLE_IT2104_REQUEST_V1,
    FILLABLE_W4_REQUEST_V1,
    FILLABLE_W8BEN_REQUEST_V1,
    FILLABLE_W9_PERSON_REQUEST_V1,
    FILLABLE_W9_COMPANY_REQUEST_V1,
    FILLABLE_ST_120_SELLER_NOTIFICATION_V1,
    FILLABLE_ST_120_PURCHASER_NOTIFICATION_V1,

    // ======================= MESSAGING ========================
    HOME_PAGE_FEEDBACK_V1,
    HOME_PAGE_FEEDBACK_V2,
    CHAT_UNSEEN_MESSAGE_V1,
    CHAT_REQUESTS_MESSAGE_V1,

    // ========================= AUTH ===========================
    PORTAL_INVITATION_V1,
    PASSWORD_RESET_V1,

    // ======================= DOCUMENTS ========================
    PAYSTUB_V1,
    FORM_W2_V1,
    LETTER_REGISTRY,
    FORM_1099_V1,
    FORM_1099_ANONYMOUS_V1,
    CUSTOM_PERSON_FORM_WITHOUT_COMPANY_V1,
    CUSTOM_COMPANY_FORM_V1,
    PAYROLL_REPORT_V1,
    DOCUMENT_SIGNED,
    BUSINESS_TAX_RETURN_V1,
    RECEIPT_HAS_BEEN_UPLOADED_V1,

    // ==================== BANK ACCOUNT ========================
    BANK_ACCOUNT_NEEDS_VERIFICATION_V1,

    // ========================= CBSR ===========================
    CBSR_NEW_V1,
    CBSR_NEW_V2,
    CBSR_NEW_DOC_UPLOADED_V1,
    CBSR_ALL_DOCS_UPLOADED_FOR_CUSTOMER_V1,
    CBSR_ALL_DOCS_UPLOADED_FOR_ASSIGNEE_V1,

    // ========================= W9CR ===========================
    W9CR_NEW_V1,
    W9CR_PERSON_FORM_V1,
    W9CR_PERSON_FORM_V2,
    W9CR_COMPANY_FORM_V1,
    W9CR_COMPANY_FORM_V2,
    W9CR_UPDATED_V1,
    W9CR_PRICES_V1,

    // ========================= RER ============================
    RER_CUSTOMER_V1,
    RER_EMPLOYEE_REGISTRATION_V1,
    RER_EMPLOYEE_UPDATE_V1,
    RER_EMPLOYEE_ALL_UPLOADED_V1,
    RER_EMPLOYEE_COMPLETED_V1,

    // ========================= RIDC ===========================
    RIDC_CUSTOMER_V1,
    RIDC_CONTRACTOR_V1,
    RIDC_CONTRACTOR_FILLED_V1,

    // ========================= PRIL ===========================
    PRIL_CUSTOMER_V1,
    PRIL_ASSIGNEE_V1,

    // ========================= ITRQ ===========================
    ITRQ_CREATE_V1,
    ITRQ_CREATE_V2,
    ITRQ_SIGNED_V1,

    // ========================= CDRQ ===========================
    CDRQ_CREATE_V1,
    CDRQ_FILLED_V1,
    CDRQ_NEW_COMMENT_V1,
    CDRQ_RESET_STEP_V1,

    // ========================= VCR ============================
    VCR_REQUEST_V1,
    VCR_APPROVE_EVENT_V1,
    VCR_CHANGE_STATUS_V1,
    VCR_REJECT_EVENT_V1,

    // ========================= SLR ============================
    SLR_REQUEST_V1,
    SLR_NEW_COMMENT_EVENT_V1,
    SLR_CANCEL_EVENT_V1,
    SLR_CLOSE_EVENT_V1,
    SLR_COMPLETE_EVENT,

    // ================== Estimated Tax Payments =================
    ETP_SUBSCRIPTION_OFFER_V1,
    ETP_SUBSCRIPTION_OFFER_DECISION_V1,
    ETP_SUBSCRIPTION_INVOICE_V1,
    ETP_CARD_PAYMENT_INVOICE_V1,

    // ========================= Signing ========================
    SIGNING_REQUEST_SIMPLE_V1,
    SIGNING_REJECTION_V1,
    SIGNING_REQUESTED_BY_COMPANY_V1,

    // ========================= IAAR ===========================
    IAAR_PERSON_LINK_V1,

    // ========================= TRDA ===========================
    TRDA_NEW_EN_V1,
    TRDA_NEW_RU_V1,
    TRDA_APPROVED_OR_REJECTED_V1,

    // ========================= CUSTOM =========================
    CUSTOM_REQUEST_NEW_V1,
    CUSTOM_REQUEST_NEW_COMMENT_V1,

    // ====================== Preparations ======================
    PREPARATION_1099_NEC_NEW_DRAFT_NOTIFICATION_V1,
    PREPARATION_1099_NEC_NEW_DRAFT_CUSTOMER_NOTIFICATION_V1,
    PREPARATION_1099_NEC_DRAFT_REPREPARED_NOTIFICATION_V2,
    PREPARATION_1099_NEC_DRAFT_REPREPARED_CUSTOMER_NOTIFICATION_V1,
    PREPARATION_1099_NEC_DRAFT_REJECTED_NOTIFICATION_V1,
    PREPARATION_1099_NEC_DRAFT_APPROVED_NOTIFICATION_V1,
    PREPARATION_1099_NEC_FILED_NOTIFICATION_V1,
    PREPARATION_1099_NEC_FILED_NOTIFICATION_V2,
    PREPARATION_1099_NEC_FILED_NOTIFICATION_V3,

    // ========================= Misc ===========================
    BSO_ID_REQUEST_V1,
    COMPANY_ADDRESS_ACTUALIZATION_V1,
    COMPANY_ADDRESS_ACTUALIZATION_NO_ADDRESS_V1,

    // ======================== Services ========================
    SERVICE_INVOICE_V1,
    CREATE_INVOICE_V1,

    // ======================== Payments ========================
    SEND_INVOICE_WITH_PAYMENT_LINK_V1,

    // ======================== Marketing ======================
    SUBLIME_DOCS_INITIAL_AD_V1,
    SUBLIME_DOCS_SUBSCRIPTION_ACTIVE_V1,
}
